import React from 'react';
import { Outlet } from 'react-router-dom';
import { Menu, Bell, User, Settings, LogOut, Search } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ThemeSwitcher } from '@/components/common/ThemeSwitcher';
import { EnhancedSidebar } from '@/components/common/EnhancedSidebar';
import { useCurrentUser } from '@/hooks/redux';
import { useLogoutMutation } from '@/store/api/authApi';
import { cn } from '@/utils';
import CategoryHeader from '@/components/header/CategoryHeader';
import ContentHeader from '@/components/header/ContentHeader';
import { useHeader } from '@/components/context/HeaderContext';
import PageSectionHeader from '@/components/header/UserManagement';
// import { AdminHeader } from '@/components/common/AdminHeader';

export function DashboardLayoutContent() {
  const user = useCurrentUser();
  const [logout] = useLogoutMutation();
  const [sidebarOpen, setSidebarOpen] = React.useState(true);
  const { header } = useHeader();

  const handleLogout = async () => {
    try {
      await logout().unwrap();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Enhanced Sidebar */}
      <EnhancedSidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />

      {/* Main Content */}
      <div className={cn('transition-all duration-300', sidebarOpen ? 'lg:ml-60' : 'lg:ml-16')}>
        {/* Top Navigation */}
        <header className="sticky top-0 z-20 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="lg:hidden"
          >
            <Menu className="h-5 w-5" />
          </Button>
        </header>
        {header && (
          <div className=" border-b shadow-sm">
            {header.type === 'category' && <CategoryHeader {...header.props} />}
            {header.type === 'content' && <ContentHeader {...header.props} />}
            {header.type === 'user' && <PageSectionHeader {...header.props} />}
          </div>
        )}
        {/* Page content */}
        <main className="flex-1 p-2 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
